/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plus_Membership_Trial_CnaInputs */

const en_plus_membership_trial_cna = /** @type {(inputs: Plus_Membership_Trial_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus Membership Trial`)
};

const ar_plus_membership_trial_cna = /** @type {(inputs: Plus_Membership_Trial_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus Membership Trial`)
};

const de_plus_membership_trial_cna = /** @type {(inputs: Plus_Membership_Trial_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus Membership Trial`)
};

const es_plus_membership_trial_cna = /** @type {(inputs: Plus_Membership_Trial_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus Membership Trial`)
};

const fr_plus_membership_trial_cna = /** @type {(inputs: Plus_Membership_Trial_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus Membership Trial`)
};

const it_plus_membership_trial_cna = /** @type {(inputs: Plus_Membership_Trial_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus Membership Trial`)
};

const ja_plus_membership_trial_cna = /** @type {(inputs: Plus_Membership_Trial_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus Membership Trial`)
};

const ko_plus_membership_trial_cna = /** @type {(inputs: Plus_Membership_Trial_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus Membership Trial`)
};

const pt_br_plus_membership_trial_cna = /** @type {(inputs: Plus_Membership_Trial_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus Membership Trial`)
};

const ru_plus_membership_trial_cna = /** @type {(inputs: Plus_Membership_Trial_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus Membership Trial`)
};

const th_plus_membership_trial_cna = /** @type {(inputs: Plus_Membership_Trial_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus Membership Trial`)
};

const tr_plus_membership_trial_cna = /** @type {(inputs: Plus_Membership_Trial_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus Membership Trial`)
};

const zh_cn_plus_membership_trial_cna = /** @type {(inputs: Plus_Membership_Trial_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus 会员体验`)
};

const zh_tw_plus_membership_trial_cna = /** @type {(inputs: Plus_Membership_Trial_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus 会员体验`)
};

/**
* | output |
* | --- |
* | "Plus Membership Trial" |
*
* @param {Plus_Membership_Trial_CnaInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const plus_membership_trial_cna = /** @type {((inputs?: Plus_Membership_Trial_CnaInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plus_Membership_Trial_CnaInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_plus_membership_trial_cna(inputs)
	if (locale === "ar") return ar_plus_membership_trial_cna(inputs)
	if (locale === "de") return de_plus_membership_trial_cna(inputs)
	if (locale === "es") return es_plus_membership_trial_cna(inputs)
	if (locale === "fr") return fr_plus_membership_trial_cna(inputs)
	if (locale === "it") return it_plus_membership_trial_cna(inputs)
	if (locale === "ja") return ja_plus_membership_trial_cna(inputs)
	if (locale === "ko") return ko_plus_membership_trial_cna(inputs)
	if (locale === "pt_br") return pt_br_plus_membership_trial_cna(inputs)
	if (locale === "ru") return ru_plus_membership_trial_cna(inputs)
	if (locale === "th") return th_plus_membership_trial_cna(inputs)
	if (locale === "tr") return tr_plus_membership_trial_cna(inputs)
	if (locale === "zh_cn") return zh_cn_plus_membership_trial_cna(inputs)
	return zh_tw_plus_membership_trial_cna(inputs)
});